export default function (cityLabel) {
  if (!cityLabel) {
    return;
  }
  const urlParams = new URLSearchParams(window.location.search);
  const currentLocation = `${window.location.protocol}//${window.location.host}${window.location.pathname}`;

  urlParams.set('city', cityLabel)
  window.history.replaceState(
    undefined,
    undefined,
    `${currentLocation}?${urlParams.toString()}`,
  )
}
